import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {HoldsActions} from '@store/holds/holds.actions';
import {FALLBACK_HOLD} from '@store/holds/holds.fallback';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {Hold} from '@store/holds/holds.types';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {ButtonRouteNameDirective} from '@lib/directives/button-route-name/button-route-name.directive';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';

@Component({
  selector: 'px-hold-icon-button',
  templateUrl: './hold-icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, ButtonRouteNameDirective, IconButtonComponent]
})
export class HoldIconButtonComponent {
  public readonly patronSelectors = PatronSelectors.Auth;
  public readonly patronStatusSelectors = PatronSelectors.AccountStatus;
  public readonly holdSelectors = HoldsSelectors.HoldsForCatalogRecords;
  public readonly holdStatelessSelectors = HoldsSelectors.Stateless;
  public readonly FALLBACK_HOLD = FALLBACK_HOLD;

  @Input({required: true}) public catalogRecordId: number;
  @Input() public visible: boolean = true;
  private readonly store = inject(Store);

  public onPlaceHold(): void {
    this.store.dispatch(HoldsActions.placeHoldByCatalogRecordId(this.catalogRecordId));
  }

  public onEditHold(hold: Hold): void {
    this.store.dispatch(HoldsActions.showEditHold({...hold}));
  }
}
